import React from "react";
import { ClipboardList, PoundSterling, Building2, Star } from "lucide-react";

const items = [
  { icon: ClipboardList, label: "100+ Deals Sourced" },
  { icon: PoundSterling, label: "£5.6M+ Investor Capital Deployed" },
  { icon: Building2, label: "BUY-TO-LET  |  BRRR  |  FLIPS" },
  { icon: Star, label: "5-Star Investor Reviews" },
];

export function TrustBar() {
  return (
    <section
      id="trust"
      data-testid="trust-bar"
      className="bg-[var(--navy-2)] border-y border-[rgba(201,168,76,0.15)]"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-7 grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-4">
        {items.map(({ icon: Icon, label }, i) => (
          <div
            key={label}
            data-testid={`trust-item-${i}`}
            className="flex items-center gap-3 reveal"
          >
            <Icon size={18} className="text-[var(--gold)] shrink-0" />
            <span
              className="text-[0.78rem] sm:text-[0.85rem] tracking-[0.12em] uppercase font-medium"
              style={{ color: "#F5F0E8" }}
            >
              {label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
